/**
 * SacType
 * @author ftgibran
 */

export enum SacType {
  TRACKING = 1,
  PENDING = 2,
  STARTED = 3,
  CHECKIN = 4,
  OCCURRENCE = 5,
  RETURNED = 6,
  ENDED = 7,
}
